import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EbayShippingCarrierResponseModel } from '../models/response-models/ebay-shipping-carrier.model';

@Injectable({
  providedIn: 'root',
})
export class EbayShippingCarrierService {
  private readonly BASE: string = `${environment.listerApiUrl}/ebay/ShippingCarriers`;

  constructor(private readonly http: HttpClient) {}

  getShippingCarriers(): Observable<EbayShippingCarrierResponseModel[]> {
    return this.http.get<EbayShippingCarrierResponseModel[]>(this.BASE);
  }
}
